import { Injectable } from '@angular/core';
import { DefaultCoursesQuestionsService } from './default-courses-questions.service';
import { CheckboxQuestion, QuestionBase, QuestionGroup } from 'core/components/forms';
import { PublishQuestion } from 'core/components/forms/publish-question';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'core/services';

@Injectable({
  providedIn: 'root'
})
export class PartnerCoursesQuestionsService extends DefaultCoursesQuestionsService {
  constructor(protected translateService: TranslateService, protected profileService: ProfileService) {
    super(translateService, profileService);
  }
  public createSpecificQuestions(params: any = {}): QuestionBase<any>[] {
    return [this.getPartnerCoursesInfoGroup(params)];
  }

  /**
   * Group of questions getting the info of the courses of partner
   * @param params necessary for the question
   * @returns Question Group object
   */
  private getPartnerCoursesInfoGroup(params?: any): QuestionGroup {
    const partnerCoursesGroup: QuestionGroup = new QuestionGroup({
      key: 'courseConfigIds',
      title: 'courses.config.title',
      isSection: false,
      hasHtml: true,
      childQuestions: [
        this.getDiplomaQuestion(params),
        this.getClientsWithAccessQuestion(params),
        this.getAccessModeQuestion(params)
      ]
        .filter((question) => question != null)
        .sort((a, b) => a.order - b.order)
    });
    return partnerCoursesGroup;
  }

  // We override this Question for partners so they can edit only their courses
  public getDiplomaQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientId, clientDetail } = params;
    const isUserCourseOwner = clientId === course.clientId;

    if (clientDetail || isUserCourseOwner) {
      return new CheckboxQuestion({
        key: 'shouldSendDiploma',
        label: 'courses.config.diploma',
        class: 'col-1',
        value:
          !course.configuration || !course.configuration.shouldSendDiploma
            ? false
            : course.configuration.shouldSendDiploma,
        order: 6
      });
    }
    return null;
  }

  public getClientsWithAccessQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientId, clientDetail } = params;
    const isUserCourseOwner = clientId === course.clientId;

    if (!clientDetail && isUserCourseOwner) {
      return new PublishQuestion({
        key: 'publish',
        label: 'courses.config.clientsWithAccess',
        class: 'col-2-offset',
        value: course.publish,
        owner: course.clientName,
        courseId: course.id,
        selector: true,
        order: 3
      });
    }
    return null;
  }
}
